/**
 * Resolve a display name from any passenger / traveller schema (Tripjack, Riya, offline).
 */
export function resolvePassengerDisplayName(p) {
  if (!p || typeof p !== 'object') return '—';
  const title = (p.title || p.ti || '').trim();
  const fn = (p.first_name || p.firstName || p.fN || p.fname || p.given_name || '').trim();
  const ln = (p.last_name || p.lastName || p.lN || p.lname || p.surname || '').trim();
  const full = (
    p.full_name || p.name || p.passenger_name || p.passengerName || ''
  ).trim();
  if (full && full !== '—') return full;
  const built = [title, fn, ln].filter(Boolean).join(' ');
  return built || '—';
}
